import { Facet } from '@ms/items-view/lib/private/models/Facet';
import {
  IMediaTransformListSchema,
  IMediaTransformItemSchema
} from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { IThumbnailURLGenerator } from '@ms/utilities-custom-formatter/lib/ICustomFormatter';

/**
 * Facet for a list which represents media transform metadata common across all items in the list.
 */
export const listMediaTransformFacet: Facet<IMediaTransformListSchema> = new Facet('listMediaTransform');

/**
 * Facet for an item which represents media transform metadata specific to that item.
 */
export const itemMediaTransformFacet: Facet<IMediaTransformItemSchema> = new Facet('itemMediaTransform');

/**
 * Facet to be stored on an item thumbnail providing a generator for per-size URLs.
 */
export const mediaTransformThumbnailUrlGeneratorFacet: Facet<IThumbnailURLGenerator> = new Facet('mediaTransformThumbnailUrlGenerator');
